<mat-toolbar class="mapv2-toolbar">
    <button mat-icon-button (click)="closePlaces()">
        <mat-icon fontSet="material-icons-outlined">arrow_back</mat-icon>
    </button>

    <h6 class="toolbar-title" *ngIf="sector">{{ sector.name }}</h6>

    <span class="toolbar-spacer"></span>

    <button mat-button
        class="btn-ticket-amount"
        [disabled]="isTicketsShowing || isCartShowing"
        (click)="openCart()"
        *ngIf="selectedPlaces.length > 0">
        <mat-icon fontSet="material-icons-outlined">local_activity</mat-icon>
        R$ {{ amount | number:'1.2-2' }}
    </button>
</mat-toolbar>

<mat-drawer-container class="mapv2-places-content">  
    <mat-drawer-content>
        <div class="mapv2-image-container">
            <div id="image-zoom" (contextmenu)="$event.preventDefault()">
                <img [src]="map.image" (load)="loadImageEvents()">
                <div class="places-container" *ngIf="sector">
                    <div
                        class="area"
                        [class.disabled]="isDisabledPlace(place)"
                        [ngStyle]="getPlaceStyle(place)"
                        (click)="openTickets(place)"
                        *ngFor="let place of map.places | placesBySector:sector.id"
                    ></div>
                </div>
            </div>
            <div class="zoom-control">
                <button mat-mini-fab (click)="zoomIn()">
                    <mat-icon fontSet="material-icons-outlined">zoom_in</mat-icon>
                </button>
                <button mat-mini-fab (click)="zoomOut()">
                    <mat-icon fontSet="material-icons-outlined">zoom_out</mat-icon>
                </button>
            </div>
            <div class="legend">
                <div class="item">
                    <span class="badge badge1"></span>
                    Disponível
                </div>
                <div class="item">
                    <span class="badge badge2"></span>
                    Indisponível
                </div>
                <div class="item">
                    <span class="badge badge3"></span>
                    Selecionado
                </div>
            </div>
            <div class="btn-done">
                <button mat-fab (click)="closePlaces()">
                    <mat-icon>done</mat-icon>
                </button>
            </div>
        </div>
    </mat-drawer-content>

    <mat-drawer 
        mode="over" 
        position="end" 
        [opened]="isTicketsShowing || isCartShowing"
        (closedStart)="closeDrawer()">
        <mapv2-tickets [place]="selectedPlace" *ngIf="isTicketsShowing && selectedPlace"></mapv2-tickets>
        <mapv2-cart *ngIf="isCartShowing"></mapv2-cart>
    </mat-drawer>
</mat-drawer-container>

<mapv2-loader [show]="loading"></mapv2-loader>